'use client';
import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import ModalFooter from "../Modal/ModalFooter.js";
var DrawerFooter = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(ModalFooter, _extends({
    classPrefix: "drawer-footer"
  }, props, {
    ref: ref
  }));
});
export default DrawerFooter;